<template>
  <el-dialog
    :title="$t('resetStaffPwd.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center>
    <div class="text-center">
      <p>{{ $t('resetStaffPwd.confirmReset') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="resetStaffPwd">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resetStaffPassword } from '@/api/frame/staffApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ResetStaffPwd',
  data() {
    return {
      dialogVisible: false,
      staffInfo: {}
    }
  },
  methods: {
    open(staffInfo) {
      this.staffInfo = staffInfo
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    async resetStaffPwd() {
      try {
        const params = {
          shopId: getShopId(),
          staffId: this.staffInfo.userId
        }
        
        const res = await resetStaffPassword(params)
        if (res.code == 0) {
          this.$message.success(
            this.$t('resetStaffPwd.resetSuccess', { pwd: res.pwd }),
            10000
          )
          this.close()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>